import React, { memo, ChangeEvent } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import useLocales from 'src/hooks/useLocales';

type ElementImageUploadProps = {
  uploadedFile: string | ArrayBuffer | null;
  elementLabel: string;
  onFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
};

const ElementImageUpload: React.FC<ElementImageUploadProps> = ({
  uploadedFile,
  elementLabel,
  onFileUpload,
}) => {
  const { t } = useLocales();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {uploadedFile && (
        <Box>
          <img src={`${uploadedFile}`} alt={elementLabel} />
        </Box>
      )}

      <Button variant="contained" component="label" id="4hjdd5">
        {t('forms.buttons.uploadImage')}
        <input
          type="file"
          accept="image/jpeg, image/png, image/jpg"
          hidden
          onChange={onFileUpload}
        />
      </Button>
    </Box>
  );
};

export default memo(ElementImageUpload);
